import {
  put,
  all,
  take,
  takeEvery,
  fork,
  select,
  cancel
} from "redux-saga/effects";

import * as R from "ramda";

// import { apiCall } from "App/Data/sagas";
import { registerError } from "redux/modules/errors/actions";

import { actions, getters } from "./model";

import {
  FIELDS_ID,
  FORM_INSTANCE_ID,
  SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION
} from "./constants";

import { debounce } from "utils/General/sagas";

import { actions as FormActions } from "ui-kit/Form/model";

import * as PortalSelectors from "redux/modules/portal/selectors";

import { actions as SearchBarActions } from "ui-kit/SearchBar";

const init = function*() {
  // load details
  try {
    yield put(actions.setLoading(true));

    // const { payload } = yield call(apiCall, {
    //   method: "get"
    //   // url:
    // });

    const { payload } = {
      payload: {
        "August 2024": [
          {
            date: "Wed, Aug. 9",
            events: [
              {
                time: "12:00am",
                timezone: "CST",
                description: "Submit passport",
                eventId: 123,
                eventName: "Base Event",
                status: "not_submitted",
                type: "task"
              }
            ]
          },
          {
            date: "Tue, Aug. 15",
            events: [
              {
                time: "3:00pm",
                timezone: "CST",
                description: "Team meeting",
                eventId: 456,
                eventName: "Base Event",
                status: "not_submitted",
                type: "task"
              },
              {
                time: "6:00pm - 8:00pm",
                timezone: "CST",
                location: "Conference Room",
                description: "Networking event",
                eventId: 789,
                eventName: "Base Event",
                type: "event"
              }
            ]
          }
        ],
        "September 2024": [
          {
            date: "Fri, Sep. 1",
            events: [
              {
                time: "9:00am",
                timezone: "CST",
                description: "Meeting",
                eventId: 456,
                eventName: "Base Event",
                status: "not_submitted",
                type: "task"
              }
            ]
          },
          {
            date: "Fri, Sep. 15",
            events: [
              {
                time: "2:00pm - 4:00pm",
                timezone: "CST",
                location: "Room ABC",
                description: "Workshop",
                eventId: 789,
                eventName: "Base Event",
                type: "event"
              }
            ]
          },
          {
            date: "Sat, Sep. 30",
            events: [
              {
                time: "10:00am",
                timezone: "CST",
                description: "Deadline for project submission",
                eventId: 123,
                eventName: "Base Event",
                status: "not_submitted",
                type: "task"
              }
            ]
          }
        ],
        "October 2024": [
          {
            date: "Thu, Oct. 5",
            events: [
              {
                time: "10:00am",
                timezone: "CST",
                description: "Submit Headshot",
                eventId: 123,
                eventName: "Base Event",
                status: "Completed",
                type: "task"
              }
            ]
          },
          {
            date: "Fri, Oct. 20",
            events: [
              {
                time: "6:00pm - 7:00pm",
                timezone: "CST",
                location: "Room BABC",
                description: "Faculty Career Partners by Organic Design",
                eventId: 123,
                eventName: "Base Event",
                type: "event"
              }
            ]
          },
          {
            date: "Tue, Oct. 31",
            events: [
              {
                time: "8:00pm",
                timezone: "CST",
                description: "Halloween Party",
                eventId: 456,
                eventName: "Base Event",
                type: "event"
              }
            ]
          }
        ]
      }
    };

    yield put(
      actions.setInitialData({
        ...payload
      })
    );

    return true;
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while saving details"
        }
      ])
    );
    return false;
  }
};

const loadEventOptions = function*({ payload: search, meta: { callback } }) {
  try {
    const portal = yield select(PortalSelectors.portal);
    const filteredEvents = R.filter(
      e => (e.name ? e.name.toLowerCase().includes(search) : false),
      portal.events || []
    );

    const options = R.map(el => ({
      value: R.prop("id", el),
      label: R.prop("name", el),
      ...el
    }))(filteredEvents);

    callback(
      R.prepend({ id: "all", value: "all", label: "All Events" }, options)
    );
  } catch (error) {
    yield all([
      put(
        registerError([
          {
            system: error,
            user: "An error occurred fetching options for async dropdown"
          }
        ])
      )
    ]);
  }
};

const search = function*() {
  const originalEvents = yield select(getters.originalData);
  yield put(actions.setData(originalEvents));
};

const watchSearch = function*() {
  let searchTask;
  for (;;) {
    const action = yield take([
      SearchBarActions.clearSearch.type,
      SearchBarActions.setSearchTerm.type
    ]);

    if (searchTask) {
      yield cancel(searchTask);
    }
    if (action.type === SearchBarActions.setSearchTerm.type) {
      if (
        R.path(["meta", "instanceId"], action) ===
        SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION
      ) {
        searchTask = yield fork(search, action);
      }
    } else if (action.type === SearchBarActions.clearSearch.type) {
      if (
        R.path(["meta", "instanceId"], action) ===
        SEARCH_BAR_INSTANCE_ID_CALENDAR_SECTION
      ) {
        searchTask = yield fork(search, action);
      }
    }
  }
};

const watchLoadAsyncDropdownEventOptions = debounce(
  action =>
    action.type === FormActions.dataRequest.type &&
    R.path(["meta", "instanceId"], action) === FORM_INSTANCE_ID &&
    R.path(["meta", "fieldId"], action) === FIELDS_ID.EVENT_FILTER,
  loadEventOptions,
  250
);

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const rootSaga = function*() {
  yield all([
    fork(watchInit),
    fork(watchLoadAsyncDropdownEventOptions),
    fork(watchSearch)
  ]);
};

export default rootSaga;
